module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.e68987a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/AmwayIcons.eot?5v2gxx
// module id = DgDd
// module chunks = 0